"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicOff = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MicOff = function MicOff(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/_react.default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.3971 17.4331L2.68808 1.72411L1.5 2.91218L7.13236 8.54454V9.24859C7.13236 10.0113 7.41104 10.6713 7.96841 11.2287C8.52578 11.7861 9.18582 12.0648 9.94854 12.0648C10.1246 12.0648 10.3299 12.0354 10.5646 11.9768L12.1047 13.5169C11.4006 13.8395 10.6819 14.0009 9.94854 14.0009C8.59912 14.0009 7.42571 13.5609 6.42832 12.6808C5.46025 11.7714 4.97622 10.6273 4.97622 9.24859H3.39212C3.39212 10.8327 3.93482 12.2261 5.02023 13.4289C6.13496 14.6023 7.46971 15.3063 9.02448 15.541V17.6825H6.19363V19.1844H13.7034V17.6825H10.8726V15.541C11.8407 15.3943 12.6474 15.1156 13.2928 14.7049L17.209 18.6212L18.3971 17.4331Z",
    fill: "#EEEEF3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.13236 3.79224L12.7647 9.3806V3.61623C12.7647 2.85351 12.486 2.19347 11.9287 1.6361C11.3713 1.07873 10.7113 0.800049 9.94854 0.800049C9.18582 0.800049 8.52578 1.07873 7.96841 1.6361C7.41104 2.19347 7.13236 2.85351 7.13236 3.61623V3.79224Z",
    fill: "#EEEEF3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.6689 12.3288C16.2263 11.3607 16.505 10.334 16.505 9.24859H14.9209C14.9209 9.9233 14.7888 10.554 14.5248 11.1407L15.6689 12.3288Z",
    fill: "#EEEEF3"
  })));
};
exports.MicOff = MicOff;